import Component from "../../lib/component";

export const CharCounterResultConfig = {
    componentTypeKey: 'CharCounterResult',
    baseHtmlClass: 'js--char_counter__result',
    selector: '.js--char_counter__result',

    maxedOutModifier: 'maxed',
};

export class CharCounterResult extends Component {

    constructor(id_or_element, charCounter) {
        super({
            element: id_or_element,
            config: CharCounterResultConfig
        });

        this.charCounter = charCounter;
    }

    render() {
        this.element.innerHTML = `${this.getCharCount()}`;
        this.conditionallySetHtmlClassState(this.isMaxedOut(), CharCounterResultConfig.maxedOutModifier);
        this.element.style.fontWeight = (this.isMaxedOut() ? 'bold' : 'normal');
    }

    getCharCount() {
        return this.charCounter.getCharCount();
    }

    isMaxedOut() {
        return this.charCounter.isMaxedOut();
    }
}